import { fundingCountryCodes } from './country-codes.js';
const countryNames = new Map();
const englishNames = new Map(fundingCountryCodes.map((country) => [country.alpha2, country.english]));
export function fundingCountryLabel(code, locale) {
    if (typeof Intl.DisplayNames !== 'function')
        return englishNames.get(code) ?? code;
    let names = countryNames.get(locale);
    if (!names) {
        names = new Intl.DisplayNames([locale], { type: 'region' });
        countryNames.set(locale, names);
    }
    return names.of(code) ?? englishNames.get(code) ?? code;
}
export function fundingLocationLabel(location) {
    const country = location?.country?.toUpperCase();
    if (!country || !englishNames.has(country))
        return null;
    const flag = String.fromCodePoint(...Array.from(country, (letter) => 127397 + letter.charCodeAt(0)));
    const state = country === 'US' ? location?.subdivision?.match(/^US-([A-Z]{2})$/)?.[1] : undefined;
    return `${flag} ${country === 'US' ? (state ? `${state}, USA` : 'USA') : country}`;
}
